export const DropdownVariant = {
  Sidebar: 'sidebar',
  Standalone: 'standalone',
  Embedded: 'embedded',
};
